// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'passbook-solid';

export const Component = () => (
  <path d='M23.563 15.224v1.006H.958v-1.006h22.605Zm0-13.218v5.412H14.8c-.047.048-.047.144-.047.239a.484.484 0 0 0-.047.195l-.001.044c0 .67-.24 1.245-.719 1.724a2.354 2.354 0 0 1-1.724.72 2.35 2.35 0 0 1-1.724-.72 2.346 2.346 0 0 1-.712-1.526l-.007-.198v-.239c-.036-.072-.045-.144-.067-.195l-.03-.044H.959V2.006h22.605ZM24.521 1H0v22.605h24.521V1Z' />
);

export const viewBox = '0 0 25 25';
